export const sfSprite = (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    <h2>Security Ops</h2>
    <p>
      Windows 11 Sem TPM auto instalável,sem animações no boot,sem bloatwares,sem telemetria.
      Instalação automática de programas via chocolatey, aumento do arquivo de paginação, 
      desativação das configurações visuais e configurações para performance.
      Limpeza automática de arquivos temporários a cada reboot.
      O melhor Windows que você já viu!
    </p>
    <p
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      <span>Visite(V)</span>
      <span>Github (G)</span>
    </p>
    <span>Saia da Placa para SAIR</span>
  </div>
);

export const iicSprite = (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    <h2>Faster⚡OS</h2>
    <p>
     O Sistema Operacional mais rápido que você já viu! Roda via browser, permite extrair,converter e compactar arquivos,
     além de ter paint, músicas, vídeos, tutoriais e alguns games.
    </p>
    <p
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      <span>Visite (V)</span>
      <span>Github (G)</span>
    </p>
    <span>Saia da placa para SAIR</span>
  </div>
);

export const chatSprite = (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    <h2>CleanAll</h2>
    <p>
      Shell script para limpar os arquivos temporários do seu linux.
      Modo paranóico para limpeza profunda do espaço livre em disco.
    </p>
    <p
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      <span>Visite (V)</span>
      <span>Github (G)</span>
    </p>
    <span>Saia da placa para SAIR</span>
  </div>
);
export const museumSprite = (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    <h2>IP MAN</h2>
    <p>
     Mostra seu IP com Geolocalização.
    </p>
    <p
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      <span>Visite (V)</span>
      <span>Github (G)</span>
    </p>
    <span>Saia da Placa para SAIR</span>
  </div>
);

export const tttSprite = (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    <h2>Chocolate</h2>
    <p>
      Otimize a instalação de programas no Windows com este script.
      Auto instalação de programas, pode adicionar quantos programas quiser.
    </p>
    <p
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      <span>Visite (V)</span>
      <span>Github (G)</span>
    </p>
    <span>Saia da placa para SAIR</span>
  </div>
);

export const vpSprite = <div>HI</div>;
